<aa-btn-action-quaternary [size]="'small'"
                          [pressed]="isPressed | async"
                          [btnWidth]="'80%'"
                          [btnText]="text | translate"
                          [cta]="onClick">
</aa-btn-action-quaternary>
